import { StoreContext } from '../StoreProvider';
import { useContext, useEffect } from 'react';
import videojs from 'video.js';

const VideoRouter = () => {
    const { customerData, player, setHideControls } = useContext(StoreContext);
    const { theVideoGramStore } = customerData;

    useEffect(() => {
        const defaultHideControls = ['fullscreen', 'playbackrates', 'timer'];
        setHideControls(!theVideoGramStore?.player?.isRoutedVideo ? defaultHideControls : ['seekbar', ...defaultHideControls]);
    }, []);

    useEffect(() => {
        if (!player || !customerData) {
            return;
        }
        const video = videojs(player.id_);
        video.pause();
        video.src(customerData.theVideoGramStore.video_uri);
        video.poster(null);
        video.load();
        video.play();
    }, [customerData]);

    return null;
}

export default VideoRouter;
